import { Injectable } from '@angular/core';
import {State, Action, StateContext, Selector} from '@ngxs/store';
import { storeAssessmentAction, storeIcuAction, storeNurisngAction } from './flowsheet.action';
 export class StoreICUAssessmentModel{
    icuObj:any[]
    assessmentObj:any[]
    nursingObj:any[]
 
 }
 @State<StoreICUAssessmentModel>({
     name: 'icuAsessment',
     defaults: {
        icuObj:[],
        assessmentObj:[],
        nursingObj:[]

      }
 })
 @Injectable()
 export class StoreICUAssessmentState {
 
     constructor( ) {
     }
  
     @Selector()
     static getICUAsssessmentData(state: StoreICUAssessmentModel) {
         return state;
     }
     @Action(storeIcuAction)
     storeIcuAction({getState, patchState}: StateContext<StoreICUAssessmentModel>, {payload}: storeIcuAction) {
         const state = getState();
        //  console.log('Action triggered with payload:', payload);
         patchState({
            icuObj: payload?.icuObj
         });
        //  console.log('State after patch:', getState());
     }
     @Action(storeAssessmentAction)
     storeAssessmentAction({getState, patchState}: StateContext<StoreICUAssessmentModel>, {payload}: storeAssessmentAction) {
         const state = getState();
        //  console.log(payload)
         patchState({
            assessmentObj:[...payload?.assessmentObj]
         });
     }
     @Action(storeNurisngAction)
     storeNurisngAction({getState, patchState}: StateContext<StoreICUAssessmentModel>, {payload}: storeAssessmentAction) {
         const state = getState();
        //  console.log(payload)
         patchState({
            nursingObj:[...payload?.nursingObj]
         });
     }
    } 